import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { TextBlock } from "components/Shared";
import RequestCoverageOption from "components/Coverage/RequestCoverageOption";

const RequestCoverage = props => {
  const [coverageRequests, setCoverageRequests] = useState([{
    countyId: null,
    volume: null,
  }]);
  const additionalInfo = useRef("");
  
  const onCountyChange = (option, index) => {
    let updatedRequests = coverageRequests.map((request, i) => {
      if (i === index) {
        return {
          ...request,
          countyId: option.value
        };
      }
      return request;
    });
    setCoverageRequests(updatedRequests);
  };

  const onVolumeChange = (value, index) => {
    let updatedRequests = coverageRequests.map((request, i) => {
      if (i === index) {
        return {
          ...request,
          volume: value
        };
      }
      return request;
    });
    setCoverageRequests(updatedRequests);
  };

  const addCoverageRequest = () => {
    let newRequest = {
      countyId: null,
      volume: null,
    };
    setCoverageRequests([...coverageRequests, newRequest]);
  };

  const onSubmit = () => {
    props.onSubmit(coverageRequests, additionalInfo.current);
  };

  return (
    <div className={"request-appraiser-coverage-container"}>
      <div className={"request-coverage-text"}>
        Looking for appraisal coverage? Mueller Reports can help. Select up to 10 states and counties below and let us know your anticipated monthly appraisal volume (optional).
      </div>
      <div className={"request-coverage-flex"}>
        <TextBlock field={"State"} placeholder={""} styleClass={"fieldText-bold-header"} />
        <TextBlock field={"County"} placeholder={""} styleClass={"fieldText-bold-header"} />
        <TextBlock field={"Monthly Volume"} placeholder={""} styleClass={"fieldText-bold-volume"} />
      </div>
      {coverageRequests.map((e, i) => i < 10 ? (
          <RequestCoverageOption 
            key={`$coverageOption${i}`}
            optionIndex={i}
            onCountyChange={onCountyChange}
            onVolumeChange={onVolumeChange}
            containerId={"request-appraiser-coverage-container"}
          />
        ) : null)}
        <Button variant="text" onClick={addCoverageRequest}>Add More</Button>
      <TextField
        id={"request-coverage-comments"}
        className={"request-coverage-comments"}
        variant="standard"
        label={"Additional information:"}
        type={"text"}
        onChange={(e) => additionalInfo.current = e.target.value}
      />
      <div className={"request-coverage-actions"}>
        <Button onClick={onSubmit}>Submit</Button>
        <Button variant="text" color="secondary" onClick={props.onCancel}>Cancel</Button>
      </div>
    </div>
  );
};

RequestCoverage.propTypes = {
  onCancel: PropTypes.func, // Function to call to dismiss display of component
  onSubmit: PropTypes.func, // Function to call with list of coverage requests and additional comments
};

export default RequestCoverage;